// extracted by mini-css-extract-plugin
export default {"tab":"HighPassword_tab__4a33w"};